<!-- Segunda pantalla de «Archivos del día»: el detalle de una generación -->
<nav style="margin-bottom:12px">
  <button type="button" class="od-btn od-btn-sm od-btn-ghost" (click)="volver.emit()"><od-icon name="chev" [size]="14" style="transform:rotate(90deg)"></od-icon>← Archivos del día</button>
</nav>

<div aria-busy="true" *ngIf="cargando && !vista">
  <div class="od-skeleton" style="height:48px;margin-bottom:10px"></div>
  <div class="od-skeleton" style="height:160px"></div>
</div>
<div class="od-alert" *ngIf="error" role="alert">
  <od-icon name="alert" [size]="16"></od-icon>
  <div class="od-alert-tx"><b>{{ noExiste ? error : 'No se pudo traer esta generación.' }}</b> {{ noExiste ? '' : error }}</div>
  <button type="button" class="od-btn od-btn-sm" *ngIf="!noExiste" (click)="recargar()">Reintentar</button>
  <button type="button" class="od-btn od-btn-sm" *ngIf="noExiste" (click)="volver.emit()">Volver</button>
</div>

<ng-container *ngIf="vista as v">
  <!-- Título, estado y acciones -->
  <header class="od-gen-cab">
    <div class="od-gen-tit">
      <h2>Archivos del {{ v.titulo }}</h2>
      <span class="od-badge" [ngClass]="'od-badge-' + v.tipoChip">{{ v.chip }}</span>
      <span class="od-muted od-gen-auto" *ngIf="v.automatico"><od-icon name="clock" [size]="12"></od-icon>automático</span>
    </div>
    <span class="od-gen-acciones">
      <button type="button" class="od-btn" *ngIf="puedeEditar && !v.ocupada" (click)="abrir('regenerar')"><od-icon name="refresh" [size]="14"></od-icon>Regenerar</button>
      <button type="button" class="od-btn" *ngIf="puedeEditar && v.yaEnviada && !v.ocupada && !v.faltaParte" (click)="abrir('reenviar')"><od-icon name="upload" [size]="14"></od-icon>Reenviar</button>
      <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEditar && !v.ocupada && ((!v.yaEnviada && v.estado === 'generado') || v.faltaParte)" (click)="abrir('enviar')"><od-icon name="upload" [size]="14"></od-icon>{{ v.faltaParte ? 'Enviar lo que falta' : 'Enviar al bucket' }}</button>
      <a class="od-btn" *ngIf="consolaUrl && v.yaEnviada" [href]="consolaUrl" target="_blank" rel="noopener noreferrer"><od-icon name="link" [size]="14"></od-icon>Ver en 3MIT</a>
    </span>
  </header>

  <div class="od-alert od-alert-mal" *ngIf="v.error" role="alert"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx">{{ v.error }}</div></div>
  <p class="od-note" *ngIf="v.estado === 'generando'">Todavía está generando; esta pantalla se actualiza sola.</p>
  <p class="od-note" *ngIf="v.estado === 'enviando'">Se está enviando; esta pantalla se actualiza sola.</p>
  <p class="od-note" *ngIf="v.faltaParte">Solo se envía lo que no llegó; lo ya entregado no se repite.</p>

  <!-- Total (y aviso de filas ya enviadas) -->
  <ng-container *ngIf="resumen as rs">
    <p class="od-gen-totalbar" aria-label="Total">
      <b>Total</b>
      <span>Giros: {{ rs.giros }}</span><span class="od-muted">·</span><span>Pagos: {{ rs.pagos }}</span>
    </p>
    <div class="od-alert od-gen-ambar" *ngIf="rs.yaGiros > 0 || rs.yaPagos > 0" role="alert">
      <od-icon name="alert" [size]="16"></od-icon>
      <div class="od-alert-tx">
        <span *ngIf="rs.yaGiros > 0">{{ rs.yaGiros }} {{ rs.yaGiros === 1 ? 'fila de giros ya se envió' : 'filas de giros ya se enviaron' }} en otro lote; no se repiten.</span>
        <span *ngIf="rs.yaPagos > 0"> {{ rs.yaPagos }} {{ rs.yaPagos === 1 ? 'fila de pagos ya se envió' : 'filas de pagos ya se enviaron' }} en otro lote; no se repiten.</span>
      </div>
    </div>
  </ng-container>
  <p class="od-muted" style="font-size:13px" *ngIf="resumenError">No se pudo traer el total. {{ resumenError }}</p>

  <!-- Dos tarjetas: Giros y Pagos -->
  <div class="od-gen-tarjetas">
    <section class="od-card" *ngFor="let a of v.archivos; trackBy: porTipo">
      <h3 class="od-card-title">{{ a.etiqueta }}</h3>
      <div class="od-srow"><span class="od-tx"><b>Archivo</b></span><span class="od-mono" style="word-break:break-all">{{ a.nombre }}</span></div>
      <div class="od-srow"><span class="od-tx"><b>Filas</b></span><span>{{ a.filas }}</span></div>
      <div class="od-srow"><span class="od-tx"><b>Total</b></span><span style="font-variant-numeric:tabular-nums">{{ a.total }}</span></div>
      <div class="od-srow" *ngIf="a.duplicados > 0">
        <span class="od-tx"><b>Duplicados omitidos</b>
          <span class="od-muted">{{ a.duplicados }} {{ a.duplicados === 1 ? 'pago ya estaba' : 'pagos ya estaban' }} en otro archivo y no se repiten.</span>
          <details class="od-gen-acc" *ngIf="a.duplicadosLista.length">
            <summary>Ver la lista</summary>
            <ul class="od-gen-lista"><li *ngFor="let d of a.duplicadosLista; trackBy: porIndice">{{ d }}</li></ul>
          </details>
        </span>
      </div>

      <!-- Revisión de este archivo -->
      <div class="od-prob" *ngFor="let p of a.problemas; trackBy: porIndice" [ngClass]="'od-prob-' + p.severidad" role="alert">
        <od-icon name="alert" [size]="14"></od-icon>
        <div>{{ p.detalle }}<span class="od-mono" style="display:block;font-size:12px" *ngIf="p.filas">{{ p.filas }}</span></div>
      </div>
      <div class="od-prob od-prob-bloquea" *ngIf="a.soloCuenta" role="alert"><od-icon name="alert" [size]="14"></od-icon><div>{{ a.soloCuenta }} {{ a.soloCuenta === 1 ? 'problema' : 'problemas' }} en este archivo.</div></div>
      <div class="od-srow" *ngIf="!a.problemas.length && !a.soloCuenta">
        <span class="od-badge od-badge-solid">Listo para enviar ✓</span>
      </div>

      <!-- Descargar y reemplazar -->
      <div class="od-gen-acciones" style="margin-top:12px">
        <button type="button" class="od-btn" [disabled]="!!descargando" (click)="descargar(a.tipo)"><od-icon name="down" [size]="14"></od-icon>Descargar</button>
        <ng-container *ngIf="puedeEditar && !v.ocupada && v.estado !== 'interrumpido'">
          <input #campo type="file" accept=".xlsx" hidden [disabled]="!!reemplazando" (change)="reemplazar(a.tipo, campo)" [attr.aria-label]="'Archivo para reemplazar el de ' + a.etiqueta.toLowerCase()">
          <button type="button" class="od-btn" [disabled]="!!reemplazando" (click)="abrirSelector(campo)"><od-icon name="upload" [size]="14"></od-icon>Reemplazar archivo</button>
          <span class="od-muted od-gen-nombre" *ngIf="elegido[a.tipo]">{{ elegido[a.tipo] }}</span>
        </ng-container>
      </div>
      <p class="od-muted" style="font-size:12px;margin-top:6px" *ngIf="puedeEditar && !v.ocupada && v.estado !== 'interrumpido'">Sube un .xlsx corregido a mano; se revisa igual que el generado.</p>
      <p class="od-muted" style="font-size:13px" *ngIf="reemplazando === a.tipo" aria-busy="true">Subiendo y revisando…</p>
      <ng-container *ngIf="resultadoReemplazo as r">
        <div *ngIf="r.tipo === a.tipo" role="status" style="margin-top:6px">
          <p style="font-size:13px"><b>{{ r.texto }}</b></p>
          <div class="od-prob" *ngFor="let p of r.problemas; trackBy: porIndice" [ngClass]="'od-prob-' + p.severidad"><od-icon name="alert" [size]="14"></od-icon><div>{{ p.detalle }}<span class="od-mono" style="display:block;font-size:12px" *ngIf="p.filas">{{ p.filas }}</span></div></div>
        </div>
      </ng-container>
    </section>
  </div>

  <p class="od-muted" style="font-size:13px;margin-top:10px" *ngIf="v.bloquea">Los problemas en rojo bloquean el envío; al enviar te pediremos confirmación.</p>
  <p class="od-muted" style="font-size:13px;margin-top:10px" *ngIf="!v.bloquea && v.avisos">Hay avisos en ámbar: se pueden enviar, pero conviene revisarlos.</p>

  <!-- Pestañas: filas de Giros, filas de Pagos e Historial -->
  <div class="od-gen-pestanas" role="tablist" aria-label="Detalle de la generación" (keydown)="teclasPestana($event)">
    <button type="button" class="od-gen-pestana" role="tab" id="odGenTab-creditos" [attr.aria-selected]="pestana === 'creditos'" [attr.tabindex]="pestana === 'creditos' ? 0 : -1" (click)="elegirPestana('creditos')">Giros · {{ resumen ? resumen.filasGiros : '…' }}</button>
    <button type="button" class="od-gen-pestana" role="tab" id="odGenTab-pagos" [attr.aria-selected]="pestana === 'pagos'" [attr.tabindex]="pestana === 'pagos' ? 0 : -1" (click)="elegirPestana('pagos')">Pagos · {{ resumen ? resumen.filasPagos : '…' }}</button>
    <button type="button" class="od-gen-pestana" role="tab" id="odGenTab-historial" [attr.aria-selected]="pestana === 'historial'" [attr.tabindex]="pestana === 'historial' ? 0 : -1" (click)="elegirPestana('historial')">Historial · {{ historial.length }}</button>
  </div>

  <!-- Filas -->
  <ng-container *ngIf="pestana !== 'historial'">
    <div class="od-gen-barra">
      <label class="od-input"><od-icon name="search"></od-icon><input type="search" [(ngModel)]="q" (ngModelChange)="cambioBusqueda()" placeholder="Buscar cédula o crédito" aria-label="Buscar cédula o crédito"></label>
      <label class="od-input"><span class="od-muted">Comercio</span>
        <select [(ngModel)]="comercio" (ngModelChange)="cambioFiltroFilas()" aria-label="Comercio"><option value="">Todos</option><option *ngFor="let c of comercios; trackBy: porTexto" [value]="c">{{ c }}</option></select>
      </label>
      <label class="od-gen-interruptor"><input type="checkbox" [(ngModel)]="soloProblemas" (ngModelChange)="cambioFiltroFilas()" aria-label="Solo con problema"> Solo con problema</label>
    </div>
    <div class="od-alert" *ngIf="errorFilas" role="alert"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx">{{ errorFilas }}</div></div>
    <div aria-busy="true" *ngIf="cargandoFilas && !filas.length"><div class="od-skeleton" style="height:40px;margin-bottom:6px"></div><div class="od-skeleton" style="height:40px"></div></div>
    <div class="od-empty" *ngIf="!cargandoFilas && !errorFilas && !filas.length"><od-icon name="file" [size]="28"></od-icon><b>Sin filas con esos filtros</b></div>
    <ng-container *ngIf="filas.length">
      <div class="od-table-wrap od-gen-wrap" [style.opacity]="cargandoFilas ? .6 : 1">
        <table class="od-table od-gen-filas-tabla" *ngIf="pestana === 'creditos'">
          <thead><tr><th>Crédito/Cuota</th><th>Cédula</th><th>Comercio</th><th>Agencia</th><th class="od-num">Monto</th><th>Vence</th><th>Estado</th></tr></thead>
          <tbody>
            <tr *ngFor="let x of filas; trackBy: porFila">
              <td data-et="Crédito/Cuota" class="od-mono">{{ x.f.credito_cuota }}</td><td data-et="Cédula">{{ x.f.cedula }}</td><td data-et="Comercio">{{ x.f.comercio }}</td><td data-et="Agencia">{{ x.f.agencia || '—' }}</td>
              <td data-et="Monto" class="od-num">{{ x.monto }}</td><td data-et="Vence">{{ x.vence }}</td>
              <td data-et="Estado"><span class="od-badge" [ngClass]="'od-badge-' + x.tipoChip">{{ x.chip }}</span><span class="od-gen-marca" *ngIf="x.problema" [title]="x.problema" [attr.aria-label]="'Problema: ' + x.problema"><od-icon name="alert" [size]="14"></od-icon></span></td>
            </tr>
          </tbody>
        </table>
        <table class="od-table od-gen-filas-tabla" *ngIf="pestana === 'pagos'">
          <thead><tr><th>Crédito/Cuota</th><th>Cédula</th><th>Comercio</th><th>Referencia</th><th>Fecha valor</th><th>Método</th><th class="od-num">Monto</th><th>Estado</th></tr></thead>
          <tbody>
            <tr *ngFor="let x of filas; trackBy: porFila">
              <td data-et="Crédito/Cuota" class="od-mono">{{ x.f.credito_cuota }}</td><td data-et="Cédula">{{ x.f.cedula }}</td><td data-et="Comercio">{{ x.f.comercio }}</td><td data-et="Referencia">{{ x.f.referencia || '—' }}</td>
              <td data-et="Fecha valor">{{ x.fechaValor }}</td><td data-et="Método">{{ x.f.metodo || '—' }}</td><td data-et="Monto" class="od-num">{{ x.monto }}</td>
              <td data-et="Estado"><span class="od-badge" [ngClass]="'od-badge-' + x.tipoChip">{{ x.chip }}</span><span class="od-gen-marca" *ngIf="x.problema" [title]="x.problema" [attr.aria-label]="'Problema: ' + x.problema"><od-icon name="alert" [size]="14"></od-icon></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <od-paginador [page]="pagina" [limit]="porPagina" [total]="totalFilas" unidad="filas" (cambiar)="irPagina($event)"></od-paginador>
    </ng-container>
  </ng-container>

  <!-- Historial: línea de tiempo -->
  <ng-container *ngIf="pestana === 'historial'">
    <p class="od-muted" style="font-size:13px" *ngIf="!historial.length">Todavía no hay movimientos.</p>
    <ol class="od-gen-linea" *ngIf="historial.length">
      <li *ngFor="let e of historial; trackBy: porIndice" [class.od-gen-mala]="e.malo">
        <b>{{ e.texto }}</b>
        <span class="od-muted" style="display:block;font-size:12px">{{ e.por }} · {{ e.cuando }}</span>
        <span style="display:block;font-size:13px" *ngIf="e.motivo">Motivo: {{ e.motivo }}</span>
        <span class="od-muted" style="display:block;font-size:13px" *ngIf="e.detalle">{{ e.detalle }}</span>
      </li>
    </ol>
    <h3 class="od-card-title" style="margin-top:16px" *ngIf="v.envios.length">Resultado de los envíos</h3>
    <div class="od-srow" *ngFor="let h of v.envios; trackBy: porIndice">
      <span class="od-tx"><b>{{ h.texto }}</b><span class="od-muted" *ngFor="let d of h.detalle; trackBy: porIndice">{{ d }}</span></span>
      <span class="od-muted" style="font-size:12px;text-align:right">{{ h.por }}<br>{{ h.cuando }}</span>
    </div>
  </ng-container>
</ng-container>

<!-- Diálogos: enviar, regenerar y reenviar -->
<div class="od-dialog-fondo" *ngIf="dialogo" (click)="cancelar()">
  <div #dlg id="odGenDlg" tabindex="-1" class="od-dialog od-gen-dlg" role="dialog" aria-modal="true" aria-labelledby="odGenDlgTitulo"
       (click)="$event.stopPropagation()" (keydown)="atrapar($event, dlg)" (keydown.escape)="$event.stopPropagation(); cancelar()">

    <ng-container *ngIf="dialogo === 'enviar'">
      <h4 id="odGenDlgTitulo" style="font-size:16px;font-weight:600">¿Enviar al bucket de 3MIT?</h4>
      <p class="od-muted" style="font-size:13px;margin-top:8px">Se envían primero los créditos y luego los pagos.</p>
      <p class="od-muted" style="font-size:13px;margin-top:6px" *ngIf="vista?.faltaParte">Solo se envía lo que no llegó; lo ya entregado no se repite.</p>
    </ng-container>

    <ng-container *ngIf="dialogo === 'regenerar'">
      <h4 id="odGenDlgTitulo" style="font-size:16px;font-weight:600">¿Volver a generar los archivos?</h4>
      <p class="od-muted" style="font-size:13px;margin-top:8px">Se arman de nuevo los giros y los pagos de este rango. Lo que reemplazaste a mano se pierde.</p>
      <label for="odGenMotivo" style="display:block;font-weight:600;font-size:13px;margin:12px 0 6px">Motivo</label>
      <label class="od-input" style="align-items:flex-start;color:var(--od-fg)">
        <textarea id="odGenMotivo" rows="2" maxlength="300" [(ngModel)]="motivo" placeholder="Por qué se vuelve a generar" aria-required="true"
          style="border:0;outline:0;background:transparent;font:inherit;width:100%;resize:vertical"></textarea>
      </label>
      <p class="od-muted" style="font-size:12px;margin-top:4px">Queda guardado en el historial.</p>
      <div class="od-alert od-gen-ambar" *ngIf="vista?.yaEnviada" role="alert" style="margin-top:10px">
        <od-icon name="alert" [size]="16"></od-icon>
        <div class="od-alert-tx">Después tendrás que reenviar; 3MIT debe rechazar o retirar el lote anterior.</div>
      </div>
    </ng-container>

    <ng-container *ngIf="dialogo === 'reenviar'">
      <h4 id="odGenDlgTitulo" style="font-size:16px;font-weight:600">¿Reenviar al bucket de 3MIT?</h4>
      <p class="od-muted" style="font-size:13px;margin-top:8px">Se envían primero los créditos y luego los pagos.</p>
      <label style="display:flex;gap:8px;align-items:flex-start;margin-top:12px;font-size:13px">
        <input type="checkbox" [(ngModel)]="confirmo3mit" aria-label="Confirmo que 3MIT rechazó o retiró el lote anterior" style="margin-top:3px">
        <span><b>Confirmo que 3MIT rechazó o retiró el lote anterior</b></span>
      </label>
    </ng-container>

    <!-- Envío bloqueado (409): problemas y «Enviar igual» -->
    <ng-container *ngIf="bloqueados as b">
      <div class="od-alert od-alert-mal" role="alert" style="margin-top:12px"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx"><b>El envío está bloqueado por estos problemas.</b></div></div>
      <div style="max-height:30vh;overflow:auto">
        <div class="od-prob" *ngFor="let p of b; trackBy: porIndice" [ngClass]="'od-prob-' + p.severidad"><od-icon name="alert" [size]="14"></od-icon><div>{{ p.detalle }}<span class="od-mono" style="display:block;font-size:12px" *ngIf="p.filas">{{ p.filas }}</span></div></div>
      </div>
      <label style="display:flex;gap:8px;align-items:center;margin-top:10px;font-size:13px">
        <input type="checkbox" [(ngModel)]="forzar" aria-label="Enviar igual"> <span><b>Enviar igual</b>, aunque haya problemas que bloquean</span>
      </label>
    </ng-container>

    <div class="od-dialog-pie">
      <button type="button" class="od-btn" [disabled]="trabajando" (click)="cancelar()">Cancelar</button>
      <button type="button" class="od-btn od-btn-primary" *ngIf="dialogo === 'regenerar'" [disabled]="trabajando || !motivoValido" (click)="confirmarRegenerar()">{{ trabajando ? 'Generando…' : 'Regenerar' }}</button>
      <button type="button" class="od-btn od-btn-primary" *ngIf="dialogo !== 'regenerar'" [disabled]="trabajando || (dialogo === 'reenviar' && !confirmo3mit) || (!!bloqueados && !forzar)"
              (click)="confirmarEnvio(dialogo === 'reenviar')">
        {{ trabajando ? 'Enviando…' : (bloqueados ? 'Enviar igual' : (dialogo === 'reenviar' ? 'Reenviar' : (vista?.faltaParte ? 'Enviar lo que falta' : 'Enviar al bucket'))) }}
      </button>
    </div>
  </div>
</div>
